const getCurrentUser = async () => {
	return {
		firstName: 'Jan',
		lastName: 'Jansen',
		roles: []
	}
}

export default { getCurrentUser }
